export class ValidationErrorDetails {
  constructor(public isError: boolean, public params: any) {}
}
